import Icon from '../components/Icon.vue'

Icon.register({
  'long-arrow-alt-down': {
    width: 256,
    height: 512,
    paths: [
      {
        d: 'M168 345.9h46.1c21.4 0 32.1 25.9 17 41l-86.1 86.1c-9.4 9.4-24.6 9.4-33.9 0l-86.1-86.1c-15.1-15.1-4.4-41 17-41h46.1v-301.9c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v301.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/long-arrow-alt-down.js
// module id = 1530
// module chunks = 0